import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=d86f2a34&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d86f2a34')) {
      api.createRecord('d86f2a34', component.options)
    } else {
      api.reload('d86f2a34', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=d86f2a34&", function () {
      api.rerender('d86f2a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YrbaQGYvq7Qq/JS/costHelpSixtyTage.vue"
export default component.exports